// Copyright 2026 FlairCV Contributors
// SPDX-License-Identifier: AGPL-3.0-or-later

import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api';

const DASHBOARD_QUERY_KEY = ['dashboard'] as const;

/** Hook for fetching dashboard summary stats. */
export function useDashboard() {
  return useQuery({
    queryKey: DASHBOARD_QUERY_KEY,
    queryFn: async () => {
      const { data, error } = await apiClient.GET('/api/v1/dashboard');

      if (error) {
        throw new Error(error.error.message);
      }

      return data.data;
    },
  });
}
